import { makeAutoObservable, reaction, runInAction } from "mobx";
import { fromPairs, IdMap } from "../collections";
import { ActivationState, PromotionInstance } from "./PromotionInstance";
import { PromotionSolver, } from "./PromotionSolver";
export class PromotionScheme {
    constructor(params) {
        this.productInstancePriceService = params.productInstancePriceService;
        this.promotionSolverVariableAssignmentFactory =
            params.promotionSolverVariableAssignmentFactory;
        this._promotionInstances = params.promotionInstances;
        this.recomputeExclusions();
        makeAutoObservable(this);
        this.startSolver();
    }
    startSolver() {
        // NOTICE We want solver to be active during the whole session, that's why this reaction is not disposed anywhere
        reaction(() => this.promotionSolverVariableAssignmentFactory.assignment, (variableAssignment) => {
            console.log("Solver invoked because cart has changed");
            const solver = new PromotionSolver({
                productInstancePriceService: this.productInstancePriceService,
                variableAssignment,
            });
            this.setPromotionInstances(solver.promotionInstances);
        }, {
            equals: (a, b) => a.eq(b),
            fireImmediately: true,
        });
    }
    setPromotionInstances(newInstances) {
        runInAction(() => {
            this._promotionInstances = this.reconcile(this._promotionInstances, newInstances);
            this.recomputeExclusions();
        });
    }
    reconcile(oldInstances, newInstances) {
        const userState = new Map();
        for (const old of oldInstances.objects) {
            if (ActivationState.isUserDecision(old.activationState)) {
                userState.set(old.promotionType.id.value, {
                    activation: old.activationState,
                    freebie: old.freebie,
                });
            }
        }
        for (const inst of newInstances.objects) {
            const prev = userState.get(inst.promotionType.id.value);
            if (prev !== undefined) {
                inst.setActivationState(prev.activation);
                if (prev.freebie !== null) {
                    inst.setFreebie(prev.freebie);
                }
            }
        }
        return newInstances;
    }
    get promotionInstances() {
        return this._promotionInstances;
    }
    clear() {
        this._promotionInstances = IdMap.empty();
    }
    recomputeExclusions() {
        this._promotionInstances.objects.forEach((promotionInstanceA) => {
            const excludedInstances = this._promotionInstances.filter((promotionInstanceB) => PromotionInstance.excludes(promotionInstanceA, promotionInstanceB));
            promotionInstanceA.setExcludedInstances(excludedInstances);
        });
    }
    disableMarketingPromotionInstances() {
        this._promotionInstances.objects.forEach((promotionInstance) => {
            if (promotionInstance.promotionType.requiresMarketing) {
                promotionInstance.setActive(false);
            }
        });
    }
    get storageData() {
        return fromPairs(this._promotionInstances.objects.map((promotionInstance) => [
            promotionInstance.id.value,
            promotionInstance.storageData,
        ]));
    }
}
